module.exports = __webpack_public_path__ + "img/5.61988b1c.jpg";